module.exports = __webpack_public_path__ + "static/media/shape2.9585c79e.svg";